module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/layouts/public-layout/public-layout.component.html
// module id = ../../../../../src/app/layouts/public-layout/public-layout.component.html
// module chunks = main